import { type ReactNode } from 'react'
import {
  ModalOverlay,
  ModalOverlayVariantNames,
} from '@/components/ModalOverlay'
import { m } from 'motion/react'
import styles from './FullscreenModal.module.css'
import { Dialog, Modal } from 'react-aria-components'
import { staticTransition } from '@/consts/springs'

export interface FullscreenModalProps {
  children?: ReactNode
  isOpen?: boolean
  'aria-label'?: string
  testId?: string
}

const contentVariants = {
  [ModalOverlayVariantNames.VISIBLE]: {
    opacity: 1,
    scale: 1,
    borderRadius: 'none',
  },
  [ModalOverlayVariantNames.HIDDEN]: {
    opacity: 0,
    scale: 0.9,
    borderRadius: 'var(--border-radius-md)',
  },
}

const MotionDialog = m.create(Dialog)

/**
 * A fullscreen modal that overlays the entire viewport with a fade animation.
 */
export function FullscreenModal({
  isOpen,
  children,
  testId,
  'aria-label': ariaLabel,
}: FullscreenModalProps) {
  return (
    <ModalOverlay isOpen={isOpen}>
      {({ isExiting, animate }) => (
        <Modal isExiting={isExiting}>
          <MotionDialog
            data-test={testId}
            className={styles.content}
            variants={contentVariants}
            initial={ModalOverlayVariantNames.HIDDEN}
            exit={ModalOverlayVariantNames.HIDDEN}
            transition={staticTransition}
            animate={animate}
            aria-label={ariaLabel}
          >
            {children}
          </MotionDialog>
        </Modal>
      )}
    </ModalOverlay>
  )
}
